var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"base-button",class:{ 'full-width': _vm.fullWidth, shrink: _vm.shrink },style:({ height: _vm.dense ? _vm.smallButtonHeight : _vm.largeButtonHeight }),attrs:{"color":_vm.color,"disabled":_vm.disabled,"elevation":"0","text":_vm.text,"loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }